import React from "react";
import {
  ComposedChart,
  Bar,
  XAxis,
  YAxis,
  ResponsiveContainer,
  LabelList,
} from "recharts";
import NoDataSkeleton from "./NoDataSkeleton";
import { roundFloat } from "../utils/DataConversion";

interface DemographicsBarChartProps {
  demoType: string;
  data: {
    name: string;
    value?: number;
    percentage?: number;
  }[];
  suppress: boolean;
  dataKey?: string;
  color: string;
  height: number;
  ltc?: boolean;
}

export default function DemographicBarChart(props: DemographicsBarChartProps) {
  const {
    data,
    height,
    demoType,
    suppress,
    dataKey = "value",
    color,
    ltc = true,
  } = props;
  const axisLabel = demoType.charAt(0).toUpperCase() + demoType.slice(1);
  return (
    <React.Fragment>
      <ResponsiveContainer height={height}>
        {!suppress ? (
          data.length ? (
            <ComposedChart
              layout="vertical"
              data={data}
              margin={{
                top: 0,
                right: 20,
                bottom: 10,
                left: 20,
              }}
            >
              <XAxis type="number" unit="%" padding={{ right: 24, left: 0 }} />
              <YAxis
                interval={0}
                dataKey="name"
                type="category"
                label={{ value: axisLabel, angle: -90, position: "left" }}
              />
              <Bar dataKey={dataKey} barSize={20} fill={color}>
                <LabelList
                  // the formatter can return a ReactNode so, we can style as such there
                  formatter={(value: string | number) =>
                    typeof value === "number" ? `${roundFloat(value, 1)}%` : ""
                  }
                  dataKey={dataKey}
                  position="right"
                  offset={10}
                />
              </Bar>
            </ComposedChart>
          ) : (
            <NoDataSkeleton message="No data found for given selection" />
          )
        ) : (
          <NoDataSkeleton ltc={ltc} />
        )}
      </ResponsiveContainer>
    </React.Fragment>
  );
}
